import { useState } from "react";
import PaymentApiService from "../../ApiServices/PaymentApiServices/PaymentApiService";
// Payment Method Icons
import { 
  Banknote, 
  X, 
} from "lucide-react";
import { useAuth } from "../Auth/AuthContext";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
import { FaPaypal } from "react-icons/fa";

const PaymentMethodModal = ({ isOpen, closeModal, fetchData }) => {
  const [formData, setFormData] = useState({
    BankAccountNumber: '',
    BankName: '',
    BankBranch: '',
    Owner: '',
    SwiftCode: '',
    Address: '',
    paymentMethod: 'bank'
  });
  const [loading, setLoading] = useState(false);
  const Auth = useAuth();
  const user = Auth.authState.user;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const paymentData = {
      BankAccountNumber: formData.BankAccountNumber,
      BankName: formData.BankName,
      BankBranch: formData.BankBranch,
      Owner: formData.Owner,
      SwiftCode: formData.SwiftCode,
      Address: formData.Address,
      UserId: user.id,
      IsActive: false,
    };

    try {
      const result = await PaymentApiService.Add(paymentData);
      if (result.message === 'Payment limit reached') {
        toast.warning(result.message);             
      } else {
        toast.success(result.message);
        fetchData();
      }
      closeModal();
    } catch (error) {
      toast.error(error.message);
      console.error('Add Payment error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${isOpen ? 'block' : 'hidden'}`}>
      <div className="absolute inset-0 bg-black bg-opacity-50" onClick={closeModal}></div>
      <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-md">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold text-gray-800">Add Payment Method</h2>
            <button 
              onClick={closeModal}
              className="text-gray-400 hover:text-gray-600"
            >
              <X size={24} />
            </button>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-2 gap-4 mb-4">
              <button
                type="button"
                className={`flex items-center justify-center p-3 rounded-lg border ${formData.paymentMethod === 'bank' ? 'border-indigo-500 bg-indigo-50' : 'border-gray-200'}`}
                onClick={() => setFormData({...formData, paymentMethod: 'bank'})}
              >
                <Banknote size={18} className="mr-2" />
                <span>Bank Transfer</span>
              </button>
              <button
                type="button"
                className={`flex items-center justify-center p-3 rounded-lg border ${formData.paymentMethod === 'paypal' ? 'border-blue-500 bg-blue-50' : 'border-gray-200'}`}
                onClick={() => setFormData({...formData, paymentMethod: 'paypal'})}
              >
                <FaPaypal size={18} className="mr-2" />
                <span>PayPal</span>
              </button>
            </div>

            {formData.paymentMethod === 'bank' && (
              <div className="space-y-4">
                {['BankAccountNumber', 'BankName', 'BankBranch', 'Owner', 'SwiftCode', 'Address'].map((field) => (
                  <div key={field} className="space-y-1">
                    <label className="text-sm font-medium text-gray-700">
                      {field.replace(/([A-Z])/g, ' $1').trim()}
                    </label>
                    <input
                      type="text"
                      name={field}
                      value={formData[field]}
                      onChange={handleInputChange}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                      required={formData.paymentMethod === 'bank'}
                    />
                  </div>
                ))}
              </div>
            )}

            {formData.paymentMethod === 'paypal' && (
              <div className="text-center py-8">
                <FaPaypal size={48} className="mx-auto text-blue-500 mb-4" />
                <p className="text-gray-600">You'll be redirected to PayPal to connect your account</p>
              </div>
            )}

            <div className="pt-4 flex justify-end space-x-3">
              <button
                type="button"
                onClick={closeModal}
                className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50 flex items-center"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Processing...
                  </>
                ) : (
                  'Save Payment Method'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodModal;